import React, { useState } from "react";
import { Upload, Button, message } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { api } from "../api";
import { compressImage } from "../utils";

// Manages an array of image URLs (the extra photos of an event album).
// Value: string[]. onChange(nextArray).
const GalleryUpload = ({ value = [], onChange }) => {
    const [uploading, setUploading] = useState(false);

    const customRequest = async ({ file, onSuccess, onError }) => {
        setUploading(true);
        try {
            const compressed = await compressImage(file);
            const { url } = await api.uploadImage(compressed);
            onChange?.([...(value || []), url]);
            onSuccess?.(url);
        } catch (err) {
            message.error(err.message || "Upload failed");
            onError?.(err);
        } finally {
            setUploading(false);
        }
    };

    const removeAt = (i) => onChange?.((value || []).filter((_, idx) => idx !== i));

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                    marginBottom: (value || []).length ? 10 : 0,
                }}
            >
                {(value || []).map((url, i) => (
                    <div
                        key={`${url}-${i}`}
                        style={{ position: "relative", width: 92, height: 92 }}
                    >
                        <img
                            src={url}
                            alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: 8,
                                border: "1px solid #eee",
                            }}
                        />
                        <Button
                            size="small"
                            danger
                            shape="circle"
                            icon={<DeleteOutlined />}
                            onClick={() => removeAt(i)}
                            style={{ position: "absolute", top: -8, right: -8 }}
                        />
                    </div>
                ))}
            </div>
            <Upload
                showUploadList={false}
                accept="image/*"
                customRequest={customRequest}
            >
                <Button icon={<PlusOutlined />} loading={uploading}>
                    Add photo
                </Button>
            </Upload>
        </div>
    );
};

export default GalleryUpload;
